module.exports = __webpack_public_path__ + "static/media/star-one.85cf2505.svg";